import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppCriteria } from '../types/decisions';
import { getEnvironmentVariable } from '../utils';

type AppPageType = 'decision' | 'form' | 'flow';

const internalRouteByType: Record<AppPageType, (id: string) => string> = {
    decision: (id) => `/apps/${id}`,
    form: (id) => `/forms/${id}`,
    flow: (id) => `/flows/${id}`,
};

export const useAppTypeGuard = (criteriaData: AppCriteria | undefined, currentPageType: AppPageType) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!criteriaData?.type) {
            return;
        }

        const { id, type } = criteriaData;

        if (type === 'cms') {
            window.location.href = `${getEnvironmentVariable('REACT_APP_PLATFORM_URL')}/page/${id}`;
            return;
        }

        if (type !== currentPageType) {
            navigate(internalRouteByType[type](id), { replace: true });
        }
    }, [
        criteriaData,
        currentPageType,
        navigate,
    ]);
};
